/* eslint-disable no-console */
import {toast} from 'react-toastify'
import {AxiosError} from 'axios'
import {
 getIsAuthFailureInProgress,
 SessionExpiredError,
} from 'utils/auth/sessionManager'

const isSessionExpiredError = (error: unknown) =>
 error instanceof SessionExpiredError ||
 (error instanceof Error &&
  error.message === 'SESSION_EXPIRED')

export function handleRejectedErrorMsg(error: AxiosError) {
 if (
  getIsAuthFailureInProgress() ||
  isSessionExpiredError(error)
 ) {
  return
 }

 let message = ''
 console.log('error.response', error.response)
 console.log('error.request', error.request)
 console.log('error.message', error.message)
 if (
  error.response?.data?.error ||
  error.response?.data?.errors
 ) {
  const data =
   error.response.data.error ?? error.response?.data?.errors
  if (
   typeof data === 'object' &&
   !Array.isArray(data) &&
   data !== null
  ) {
   for (const key in data) {
    if (Array.isArray(data[key])) {
     for (const err of data[key]) {
      message += `${err}\n`
     }
    } else {
     message += `${data[key]}\n`
    }
   }
  } else if (Array.isArray(data)) {
   for (const err of data) {
    message += `${err}\n`
   }
  } else if (typeof data === 'string') {
   message += `${data}\n`
  }
 } else if (error.response?.data?.message) {
  message += `${error.response?.data?.message}`
 } else if (error.message) {
  message += `${error.message}`
 } else if (error.request) {
  message += `${error.request}`
 }
 toast.error(message ?? error)
}

export function showErrorMsg(message: string) {
 toast.error(message)
}
